import React, {Component} from 'react';
import PropTypes from 'prop-types';
import propertyWriter from '../../lib/urlWriters/webURL';
import {Link} from 'react-router-dom';

class ExpiryNotification extends Component {
  render() {
    let property = this.props.property;
    return (
      property.category !== 'Property' && property.listing.status !== 'current' ?
        <div className="mb-4 alert alert-primary text-center" role="alert">
          <span>
            This ad is no longer active.
            <Link
              to={propertyWriter(property)}
              className="ml-2">
              View property report
            </Link>
          </span>
        </div>
        : null
    );
  }
}

ExpiryNotification.propTypes = {
  property: PropTypes.object,
};


export default ExpiryNotification;
